module.exports = {
  global: {
    ruleLabel: 'Rules',
    shareSuccess: "Share Successfully",
    shareFail: "Share Fail",
    moreButtonLabel: 'View More',
    goShopping: 'Go Buy',
    gameOver: 'Dear friends, the event is over!',
    moreGame: 'Discover more exciting things >',
    acquired: 'Acquired',
    outOfScope: 'Your current location is outside the active range',
    switchPositioning: 'Change location to get information',
    cashCoupons:'Cash coupons',
    discountCoupon:'Discount Coupon',
    minDiscountCoupon:'Discount Coupon',
    openApp: 'Open APP',
    shareText: 'I found a super awesome content on the WOWNOW and recommend it to you',
    sort: 'Sort',
    store_rest: 'Closed, business Hours: {value}',
    resting: 'Closed',
    delivery_busy_available: 'Busy · will be available in 30 minutes',
    delivery_busy: 'Busy',
    stoped: 'Closed',
    not_in_scope: 'Not in the scope of delivery',
    delivery_shipping_fee_reduce: "Reduced",
  },
  enums: {
    sortType: {
      wm_sort_Find_more: 'Find more',
      wm_sort_Good_rates: 'Good rates',
      wm_sort_Best_sell: 'Best sell',
      wm_sort_Nearest: 'Nearest'
    },
    flag_new: 'New',
    hide: 'Closed',
    expand: 'Open More',
  },
  cmsCoupon: {
    deliveryCoupons: 'delivery fee coupon',
    notThreshold: "No limit",
    hasThreshold: "Can use from {money}",
    notStart: 'Event Has Not Started',
    endAct: "Event Ended",
    amountHasOut: 'Amount Has Out',
    goToUse: "Go to use",
    successToast: 'Receive successful',
    clickToRedeem: "Click To Redeem"
  },
  cmsSuperCoupon: {
    csuper_pageTitle: "WOWcoupons",
    csuper_coupon: "WOWcoupons",
    discount: "Discount {value} %",
    purchase_history: 'Purchase history',
    delivery_up_to_off: 'Up to {money} off',
    can_expand_up_to: 'WOWMEGA Save up to {money}',
    purchasing: 'Buy',
    delivery_piece: 'Piece',
    group_on_score_empty: "No ratings yet",
  }
}
